<ng-template #selectAll>
	<mat-option *ngIf="canEdit && props.allowSelectAll === true" (click)="toggleSelectAll()">
		<mat-pseudo-checkbox class="mat-option-pseudo-checkbox" [state]="state">
		</mat-pseudo-checkbox>
		{{ selectAllLabel }}
	</mat-option>
</ng-template>

<mat-form-field style="width: 100%;">
	<mat-label>{{ props.label }}</mat-label>
	<mat-select placeholder="Select" multiple [formControl]="formControl">
		<mat-select-trigger>
			{{ getSelectedDisplay() }}
		</mat-select-trigger>
		<ng-container [ngTemplateOutlet]="selectAll"></ng-container>
		<ng-container *ngIf="canEdit; else optionIsReadonly">
			<mat-option *ngFor="let option of selectOptions" [(value)]="option.value" (click)="handleCheckboxSelection(option.value)">
				{{option.label}}
			</mat-option>
		</ng-container>
		<ng-template #optionIsReadonly>
			<mat-option *ngFor="let option of selectOptions" disabled [(value)]="option.value" (click)="handleCheckboxSelection(option.value)">
				{{option.label}}
			</mat-option>
		</ng-template>
	</mat-select>
	<mat-error *ngIf="props.required === true">{{requiredErrorMessage}}</mat-error>
</mat-form-field>
<mat-chip-set aria-label="Chip List" class="formly-chips-list-wrapper">
	<div class="scrollable-chips" [ngClass]="{'scroll-3-rows': props.scrollAfter3Rows === true, 'scroll-6-rows' : props.scrollAfter6Rows === true }">
		<ng-container *ngIf="!(props.excludeChipsWhenAll && state === 'checked')">
			<mat-chip *ngIf="selections.length > 0 && props.allowClearAllChip === true && canEdit" class="linq-chip">
				CLEAR ALL
				<button matChipRemove (click)="removeChip(null, -1)">
					<mat-icon>cancel</mat-icon>
				</button>
			</mat-chip>
			<mat-chip *ngFor=" let chip of selections; let i=index" (removed)="removeChip(chip, i)" class="linq-chip">
				<ng-container *ngIf="props.useKeyAsChipDisplay !== true; else useKeyForChip">
					{{ chip.label }}
				</ng-container>
				<ng-template #useKeyForChip>
					{{ chip.key }}
				</ng-template>

				<button matChipRemove *ngIf="props.allowRemoveChip === true && canEdit">
					<mat-icon>close</mat-icon>
				</button>
			</mat-chip>
		</ng-container>
	</div>

</mat-chip-set>
